import React, { useEffect, useState } from 'react'
import classnames from "classnames";
import { CardBody, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import SatelliteCommunication from 'VesselMaster/AdditionalInformation/SatelliteComm';
import VesselGeneralInfo from 'VesselMaster/AdditionalInformation/VesselGeneralInfo/VesselGeneralInfo';
import EmailReporting from 'VesselMaster/AdditionalInformation/EmailReporting';
import SaveBeforeChange from 'VesselMaster/SaveBeforeChange';
import PopUp from 'Components/PopUp';
import { FormikProps } from 'formik';
import { OnboardingStatus, Roles, VesselConfigrationTabs, VesselDataConstants } from 'shared/constants';
import { getTabStatus } from 'GenericForms/Helper';
import { hasRole } from 'utils/auth/authUtils';
import { useSelector } from 'react-redux';
import { RootState } from 'index';
interface VesselDataType {
    setCheckValuesBeforeSwitch: (value: boolean) => void;
    setTabName: (value: string) => void;
    VesselConfActiveTab: any;
    setFormik?: (value: FormikProps<any>) => void;
    formik?: FormikProps<any>;
    refreshVesselMachineries: number;
    setRefreshVesselMachineries: (value: number) => void;
    setRefreshForm: (value: boolean) => void;
    refreshForm: boolean;
    setDisableYesButton?: (value: boolean) => void;
    saveBeforeChangePopUp?: boolean;
    subTabsStatus?: any;
}

const VesselData: React.FC<VesselDataType> = ({
    setCheckValuesBeforeSwitch,
    setTabName,
    VesselConfActiveTab,
    setFormik,
    formik,
    setRefreshForm,
    refreshForm,
    setDisableYesButton,
    subTabsStatus,
    saveBeforeChangePopUp,
}) => {
    const [activeSettingsTab, setActiveSettingsTab] = useState(VesselDataConstants.VESSEL_GENERAL_INFO);
    const { VesselID, Vessels } = useSelector((state: RootState) => state.Reporting);
    const vessel = Vessels.find((rec: { [key: string]: string | number | boolean | Date | null }) => rec.id === VesselID);
    const [checkVesselDataValuesBeforeSwitch, setCheckVesselDataValuesBeforeSwitch] = useState(false);
    const [vesselDataTabName, setVesselDataTabName] = useState("");
    const [saveBeforeChangePopUpInsideTab, setSaveBeforeChangePopUpInsideTab] = useState(false);
    const [nextTab, setNextTab] = useState<number | null>(null);
    const [tabFormik, setTabFormik] = useState<FormikProps<any>>(null);
    const [disableYesButtonInsideTab, setDisableYesButtonInsideTab] = useState(false);
    const [refreshKey, setRefreshKey] = useState<number>(0);
    useEffect(() => {
        if (VesselConfActiveTab === VesselConfigrationTabs.VESSEL_DATA && tabFormik?.values !== tabFormik?.initialValues) {
            setDisableYesButton(disableYesButtonInsideTab);
            setFormik(tabFormik);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, [activeSettingsTab, VesselConfActiveTab, tabFormik])

    const toggle = (tab: any) => {
        const isSameTab = activeSettingsTab === tab;
        const isManagerWithOnboardedVessel =
            hasRole(Roles.MANAGER) && vessel.onboarding_status !== OnboardingStatus.PENDING;

        if (!isSameTab) {
            if (checkVesselDataValuesBeforeSwitch || isManagerWithOnboardedVessel) {
                // Switch immediately if validation passes or manager with onboarded vessel
                setActiveSettingsTab(tab);
            } else {
                // Store the next tab and show confirmation popup
                setNextTab(tab);
                setSaveBeforeChangePopUpInsideTab(true);
            }
            // Refresh the form
            setRefreshForm(!refreshForm);
        }
    };

    const handleSaveAndSwitchTab = async (formik: any) => {
        if (formik) {
            await formik?.submitForm();
            formik.initialValues = formik.values;
            formik?.resetForm({ values: formik.initialValues });
            setRefreshForm(!refreshForm);
            setRefreshKey(refreshKey + 1);
        }
        setCheckValuesBeforeSwitch(true);
        if (nextTab !== null) {
            setActiveSettingsTab(nextTab);
            setNextTab(null);
        }
        setSaveBeforeChangePopUpInsideTab(false);
    };

    const handleNoSaveAndSwitchTab = (formik: any) => {
        formik?.resetForm({ values: formik.initialValues });
        setRefreshForm(!refreshForm);
        setRefreshKey(refreshKey + 1);
        setCheckValuesBeforeSwitch(true);
        if (nextTab !== null) {
            setActiveSettingsTab(nextTab);
            setNextTab(null);
        }
        setSaveBeforeChangePopUpInsideTab(false);
    };

    const renderStatusIcon = (status: string) => {
        if (status === 'completed') {
            return <i className="bx bx-check-double text-success me-2" />;
        } else if (status === 'pending') {
            return <i className="mdi mdi-clock-edit-outline text-warning me-2" />;
        } else {
            return null;
        }
    };

    return (
        <React.Fragment>
            <PopUp
                state={saveBeforeChangePopUpInsideTab}
                setState={setSaveBeforeChangePopUpInsideTab}
                body={
                    <SaveBeforeChange
                        tabName={vesselDataTabName}
                        onYes={() => handleSaveAndSwitchTab(tabFormik)} // Save and switch
                        onNo={() => {
                            handleNoSaveAndSwitchTab(tabFormik);
                            setDisableYesButtonInsideTab(false);
                        }} // Discard and switch
                        disableYesButton={disableYesButtonInsideTab}
                    />
                }
                title="Alert"
                size="sm"
            />
            <CardBody className='pb-0 pt-0'>
                <Nav tabs className='nav-tabs-custom nav-justified'>
                    <NavItem>
                        <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({
                                active: activeSettingsTab === VesselDataConstants.VESSEL_GENERAL_INFO,
                            })}
                            onClick={() => {
                                setFormik(null);
                                setTabFormik(null);
                                toggle(VesselDataConstants.VESSEL_GENERAL_INFO);
                            }} to={''}
                        > {renderStatusIcon(getTabStatus('vessel general information', subTabsStatus))}
                            Vessel General Information
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({
                                active: activeSettingsTab === VesselDataConstants.SATELLITE_COMMUNICATION,
                            })}
                            onClick={() => {
                                setFormik(null);
                                setTabFormik(null);
                                toggle(VesselDataConstants.SATELLITE_COMMUNICATION);
                            }} to={''}
                        >   {renderStatusIcon(getTabStatus('satellite communication', subTabsStatus))}
                            Satellite Communication
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({
                                active: activeSettingsTab === VesselDataConstants.EMAIL_REPORTING,
                            })}
                            onClick={() => {
                                toggle(VesselDataConstants.EMAIL_REPORTING);
                            }} to={''}
                        > {renderStatusIcon(getTabStatus('email reporting', subTabsStatus))}
                            Email Reporting
                        </NavLink>
                    </NavItem>
                </Nav>
            </CardBody>
            <TabContent activeTab={activeSettingsTab} className="p-3 text-muted">
                <TabPane tabId={VesselDataConstants.VESSEL_GENERAL_INFO} className='m-0'>
                    <VesselGeneralInfo
                        activeTab={activeSettingsTab}
                        VesselConfActiveTab={VesselConfActiveTab}
                        setCheckVesselDataValuesBeforeSwitch={setCheckVesselDataValuesBeforeSwitch}
                        setVesselDataTabName={setVesselDataTabName}
                        setCheckValuesBeforeSwitch={setCheckValuesBeforeSwitch}
                        setTabName={setTabName}
                        setFormik={setFormik}
                        setTabFormik={setTabFormik}
                        refreshForm={refreshForm}
                        setDisableYesButtonInsideTab={setDisableYesButtonInsideTab}
                        saveBeforeChangePopUpInsideTab={saveBeforeChangePopUpInsideTab}
                        saveBeforeChangePopUp={saveBeforeChangePopUp}
                        setRefreshKey={setRefreshKey}
                        refreshKey={refreshKey}
                    />
                </TabPane>
                <TabPane tabId={VesselDataConstants.SATELLITE_COMMUNICATION}>
                    <SatelliteCommunication
                        activeTab={activeSettingsTab}
                        VesselConfActiveTab={VesselConfActiveTab}
                        setCheckVesselDataValuesBeforeSwitch={setCheckVesselDataValuesBeforeSwitch}
                        setVesselDataTabName={setVesselDataTabName}
                        setCheckValuesBeforeSwitch={setCheckValuesBeforeSwitch}
                        setTabName={setTabName}
                        setFormik={setFormik}
                        formik={formik}
                        setTabFormik={setTabFormik}
                        setDisableYesButtonInsideTab={setDisableYesButtonInsideTab}
                        saveBeforeChangePopUpInsideTab={saveBeforeChangePopUpInsideTab}
                        saveBeforeChangePopUp={saveBeforeChangePopUp}
                        setRefreshKey={setRefreshKey}
                        refreshKey={refreshKey}
                    />
                </TabPane>
                <TabPane tabId={VesselDataConstants.EMAIL_REPORTING}>
                    <EmailReporting
                        activeTab={activeSettingsTab as any}
                        VesselConfActiveTab={VesselConfActiveTab}
                        setCheckVesselDataValuesBeforeSwitch={setCheckVesselDataValuesBeforeSwitch}
                        setVesselDataTabName={setVesselDataTabName}
                        setCheckValuesBeforeSwitch={setCheckValuesBeforeSwitch}
                        setTabName={setTabName}
                        setFormik={setFormik}
                        formik={formik}
                        setTabFormik={setTabFormik}
                        setDisableYesButtonInsideTab={setDisableYesButtonInsideTab}
                        saveBeforeChangePopUpInsideTab={saveBeforeChangePopUpInsideTab}
                        saveBeforeChangePopUp={saveBeforeChangePopUp}
                        setRefreshKey={setRefreshKey}
                        refreshKey={refreshKey}
                    />
                </TabPane>
            </TabContent>
        </React.Fragment>
    )
}

export default VesselData